import carbonNeutralIcon from './assets/carbon-neutral.svg';
import localSupportIcon from './assets/local-support.svg';
import securePaymentIcon from './assets/secure-payment.svg';
import shippingIcon from './assets/shipping.svg';
import starChatIcon from './assets/star-chat.svg';
import thumbsUpIcon from './assets/thumb-up.svg';
import type { TrustSignalProps } from './TrustSignal';

import { TrustSignal } from './TrustSignal';
import {
  ethicalPolicyUrl,
  helpCenterUrl,
  returnExchangePolicyHelpUrl,
  securePaymentsHelpUrl,
  shippingHelpUrl,
} from './urls';

export {
  carbonNeutralIcon,
  ethicalPolicyUrl,
  helpCenterUrl,
  localSupportIcon,
  returnExchangePolicyHelpUrl,
  securePaymentIcon,
  securePaymentsHelpUrl,
  shippingHelpUrl,
  shippingIcon,
  starChatIcon,
  TrustSignal,
  TrustSignalProps,
  thumbsUpIcon,
};
